<template>
  <div class="enroll">
    <div class="active" v-if="active !== null && active">
      <img src="../../assets/img/enroll-water.png" alt="" />
      <div class="right-mes">
        <img class="logo" src="../../assets/img/home-logo.png" alt="" />
        <p class="title">Freshwater algae database</p>
        <el-form
          :model="loginForm"
          :rules="rules"
          ref="loginForm"
          label-width="32px"
          class="login-form-content"
          hide-required-asterisk
        >
          <el-form-item
            prop="email"
            style="border-bottom: none;"
            :show-message="false"
          >
            <i slot="label" class="icon-label">
              <img
                src="../../assets/img/enroll-mail.png"
                alt=""
                class="email-img"
              />
            </i>
            <p>{{ mail }}</p>
          </el-form-item>
          <el-form-item prop="password" class="password">
            <i slot="label" class="icon-label">
              <img
                src="../../assets/img/enroll-pasw.png"
                alt=""
                class="pasw-img"
              />
            </i>
            <el-input
              ref="passwordInput"
              :type="passwordVisible ? 'text' : 'password'"
              v-model.trim="loginForm.password"
              autocomplete="off"
              placeholder="Please input a password"
              @keyup.enter.native="submitForm('loginForm')"
              suffix-icon="null"
            ></el-input>
            <i
              class="pw-eye"
              :class="
                passwordVisible
                  ? 'iconfont icon-xiaoyanjing-zheng'
                  : 'iconfont icon-xiaoyanjing-bi'
              "
              @click="passwordVisible = !passwordVisible"
            ></i>
          </el-form-item>
          <el-form-item
            prop="rePassword"
            class="password"
            :show-message="false"
          >
            <i slot="label" class="icon-label">
              <img
                src="../../assets/img/enroll-pasw.png"
                alt=""
                class="pasw-img"
              />
            </i>
            <el-input
              ref="passwordInput"
              :type="rePasswordVisible ? 'text' : 'password'"
              v-model.trim="loginForm.rePassword"
              autocomplete="off"
              placeholder="Please enter the password again"
              @keyup.enter.native="submitForm('loginForm')"
              suffix-icon="null"
            ></el-input>
            <i
              class="pw-eye"
              :class="
                rePasswordVisible
                  ? 'iconfont icon-xiaoyanjing-zheng'
                  : 'iconfont icon-xiaoyanjing-bi'
              "
              @click="rePasswordVisible = !rePasswordVisible"
            ></i>
          </el-form-item>
          <el-form-item class="submit-btn">
            <el-button @click="submitForm('loginForm')"
              >Set your password and log in</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="not-active" v-if="active !== null && !active">
      <div class="header-box">
        <img src="../../assets/img/home-logo.png" alt="logo" />
        <p>FWAlgaeDB</p>
      </div>
      <div class="box">
        <img src="../../assets/img/invalid.png" alt="" />
        <p class="invalid-title">
          This application has expired, please apply again!
        </p>
        <p>
          The application is valid for 15 minutes. If you have any questions,
          please contact xxxxxxxxx by email 163.com
        </p>
        <button @click="toLogin">Confirm</button>
      </div>
    </div>
  </div>
</template>

<script>
import http from '../../utils/http'
import validate from '@/utils/validate'
import { Message } from 'element-ui'
export default {
  name: 'Changepasw',
  data () {
    let checkPasw = (rule, value, callback) => {
      if (this.loginForm.rePassword === this.loginForm.password) {
        callback()
      } else {
        callback(new Error('The two passwords are inconsistent'))
      }
    }
    return {
      mail: '',
      active: null,
      firstActive: null,
      loginForm: {
        email: '',
        password: '',
        rePassword: ''
      },
      rules: {
        password: [
          {
            required: true,
            trigger: 'blur',
            validator: (rule, value, callback) => {
              let error = []
              let checkRes = validate.checkPassword(value)
              if (!checkRes.data) {
                error.push(checkRes.msg)
              }
              callback(error)
            }
          }
        ],
        rePassword: [{ required: true, trigger: 'blur', validator: checkPasw }]
      },
      passwordVisible: false,
      rePasswordVisible: false
    }
  },
  created () {
    this.$store.commit('toTop')
    if (this.$route.query.auditId !== undefined) {
      this.firstActive = true // 激活设置密码
    } else {
      this.firstActive = false // 修改密码
    }
    if (this.firstActive) {
      http.get(
        `/auditCheckSettingPasswordById?auditId=${this.$route.query.auditId}&id=${this.$route.query.id}`,
        {},
        res => {
          if (res.code === 200) {
            this.active = true
            this.mail = res.data.email
          } else {
            this.active = false
          }
        }
      )
    } else {
      http.get(
        `/auditCheckResetPassword?id=${this.$route.query.id}`,
        {},
        res => {
          if (res.code === 200) {
            this.active = true
            this.mail = res.data.username
          } else {
            this.active = false
          }
        }
      )
    }
  },
  methods: {
    submitForm (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let { password } = this.loginForm
          password = this.$md5(password)
          if (this.firstActive) {
            http.post(
              `/auditSetPassword?auditId=${this.$route.query.auditId}&password=${password}`,
              {},
              res => {
                if (res.code === 200) {
                  Message.success(
                    `Activate successfully and enter the login page`
                  )
                  setTimeout(() => {
                    this.$router.push('/login')
                  }, 1000)
                } else {
                  Message.error(`${res.msg}`)
                }
              }
            )
          } else {
            http.post(
              `/auditResetPassword?id=${this.$route.query.id}&password=${password}`,
              {},
              res => {
                if (res.code === 200) {
                  Message.success(
                    `After modification, enter the login page`
                  )
                  setTimeout(() => {
                    this.$router.push('/login')
                  }, 1000)
                } else {
                  Message.error(`${res.msg}`)
                }
              }
            )
          }
        }
      })
    },
    toLogin () {
      this.$router.push('/login')
    }
  }
}
</script>

<style lang="scss" scoped>
.enroll {box-sizing: border-box;
  min-width: vw(1200);
  .active {
    padding: vw(0) vw(282) vw(0) vw(20);
    display: flex;
    img {
      width: vw(980);
      height: vw(919);
      margin-right: vw(216);
    }
    .right-mes {
      margin-top: vw(160);
      .logo {
        margin-bottom: vw(43);
        width: vw(186);
        height: vw(43);
      }
      .title {
        margin-bottom: vw(60);
        color: #333333;
        font-size: vw(30);
        font-weight: bold;
      }
      .login-form-content {
        .el-form-item {
          border-bottom: 1px solid #dddddd;
          margin: vw(40) 0 0 0;
          >>> .el-form-item__label {
            padding: 0;
            height: 100%;
            .icon-label {
              display: inline-block;
              width: 100%;
              height: 100%;
              position: relative;
              img {
                position: absolute;
                top: 50%;
                left: 0;
                transform: translateY(-75%);
              }
              .email-img {
                width: vw(24);
                height: vw(19);
              }
              .pasw-img {
                width: vw(21);
                height: vw(25);
              }
            }
          }
          >>> .el-form-item__content {
            .el-input {
              .el-input__inner {
                border: none;
                font-size: vw(16);
                padding: 0;
              }
            }
          }
          &.is-error {
            border-bottom: 1px solid red;
          }
          &.password {
            >>> .el-form-item__content {
              position: relative;
              .pw-eye {
                position: absolute;
                top: 0;
                right: 7px;
                cursor: pointer;
                color: #999;
                font-size: vw(16);
              }
            }
          }
        }
        .submit-btn {
          border: none;
          margin: vw(80) 0 0 0;
          >>> .el-form-item__content {
            width: 100%;
            margin-left: 0 !important;
            .el-button {
              width: 100%;
              height: vw(60);
              background: $theme_color;
              font-size: vw(22);
              font-weight: 400;
              color: #fbf9fa;
              border-radius: 4px;
              border: none;
              &:focus {
                outline: 0;
              }
              &:hover {
                background: $theme_color_hover;
              }
            }
          }
        }
      }
    }
  }
  .not-active {
    position: relative;
    &::after {
      content: '';
      display: block;
      position: absolute;
      top: vw(85);
      left: 0;
      height: 1px;
      width: 100%;
      background: #dddddd;
    }
    .header-box {
      width: vw(1200);
      margin: 0 auto;
      padding-top: vw(18);
      padding-bottom: vw(24);
      display: flex;
      align-items: center;
      color: #333333;
      font-size: vw(24);
      img {
        margin-right: vw(39);
        width: vw(186);
        height: vw(43);
      }
    }
    .box {
      width: vw(1200);
      margin: vw(58) auto 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      img {
        width: vw(353);
        height: vw(343);
      }
      p {
        font-size: vw(14);
        color: #999999;
      }
      .invalid-title {
        margin-top: vw(75);
        margin-bottom: vw(22);
        font-size: vw(18);
        color: #333333;
      }
      button {
        margin-top: vw(91);
        width: vw(158);
        height: vw(36);
        border-radius: 4px;
        background-color: #e9575a;
        font-size: vw(16);
        color: #fbf9fa;
        cursor: pointer;
        outline: none;
        border: none;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/enroll/changepasw.vue